import { fetchWithAuth, utilsDatetime } from './utils';

export const fetchGraph = async (id, monthIndex, aggr_type) => {
  const url = new URL(`${process.env.REACT_APP_API_URL}/reports/graph/v2`) // /v2`);

  url.searchParams.append('_id', id);
  url.searchParams.append('month', monthIndex + 1);
  url.searchParams.append('aggr_type', aggr_type);

  try {
    const response = await fetchWithAuth(url, {
      method: 'POST',
    });

    if (!response.ok) {
      throw new Error(`Error: ${response.statusText}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Failed to fetch device list:', error);
    throw error;
  }
};

export async function getDevDetailReports(id, fromDate, toDate, selectedOption) {

  const formData = new FormData();
  formData.append('startDate', fromDate);
  formData.append('endDate', toDate);
  formData.append('detail', selectedOption);

  const url = new URL(`${process.env.REACT_APP_API_URL}/reports/device`);
  url.searchParams.append('_id', id);

  try {
    let response = await fetchWithAuth(url, {
      method: 'POST',
      body: formData,
    });

    if (!response.ok) {
      throw new Error(`POST request failed: ${response.status}`);
    }

    let data = await response.json();

    return data;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
}


export async function exportBalanceToExcel({ dataToExport }) {

  const { startDateISO, endDateISO, fullAddress } = dataToExport;

  const url = new URL(`${process.env.REACT_APP_API_URL}/reports/water-balance`);

  url.searchParams.append('address', fullAddress)
  url.searchParams.append('startDate', startDateISO);
  url.searchParams.append('endDate', endDateISO);

  const response = await fetchWithAuth(url);

  if (response.ok) {
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `Баланс_за_период_${utilsDatetime()}.xlsx`;

    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  } else {
    console.error('Error:', response.statusText);
  }
}


export async function createAutomatization(payload) {

  const url = new URL(`${process.env.REACT_APP_API_URL}/auto/report-schedule`);


  const response = await fetchWithAuth(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Failed to create schedule');
  }

  return await response.json();
}



export async function exportErip({ dataToExport }) {

  const { aggregateData, startDateISO, endDateISO, fullAddress, searchQuery, order, user } = dataToExport;


  try {

    const url = new URL(`${process.env.REACT_APP_API_URL}/reports/eripcsv`);

    url.searchParams.append('limit', 0);
    url.searchParams.append('offset', 0);
    url.searchParams.append('address', fullAddress)
    url.searchParams.append('search', searchQuery)
    url.searchParams.append('order', order)
    url.searchParams.append('detail', aggregateData);
    url.searchParams.append('startDate', startDateISO);
    url.searchParams.append('endDate', endDateISO);
    url.searchParams.append('user', user.email);


    const response = await fetchWithAuth(url);

    if (response.ok) {
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const contentDisposition = response.headers.get('Content-Disposition');
      
      const filename = getFilenameFromContentDisposition(contentDisposition);

      const a = document.createElement('a');
      a.href = url;
      a.download = filename;

      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } else {
      console.error('Error:', response.statusText);
    }
  } catch (error) {
    console.error('Error:', error);
  }

}

function getFilenameFromContentDisposition(header) {
  if (!header) return null;

  // filename="xxx" или filename=xxx
  const match = header.match(/filename\*?=(?:UTF-8'')?["']?([^;"']+)/i);
  return match ? decodeURIComponent(match[1]) : null;
}

export async function exportToExel({ dataToExport }) {

  const { aggregateData, startDateISO, endDateISO, fullAddress, searchQuery, order, user } = dataToExport;

  try {

    const url = new URL(`${process.env.REACT_APP_API_URL}/reports/excel`);

    url.searchParams.append('limit', 0);
    url.searchParams.append('offset', 0);
    url.searchParams.append('address', fullAddress)
    url.searchParams.append('search', searchQuery)
    url.searchParams.append('order', order)
    url.searchParams.append('detail', aggregateData);
    url.searchParams.append('startDate', startDateISO);
    url.searchParams.append('endDate', endDateISO);
    url.searchParams.append('user', user.email);

    const response = await fetchWithAuth(url);

    if (response.ok) {
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `Отчет_за_период_${utilsDatetime()}.xlsx`;

      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } else {
      console.error('Error:', response.statusText);
    }
  } catch (error) {
    console.error('Error:', error);
  }
}


export async function exportTemplatesXLSX({ dataToExport }) {

  try {
    const url = new URL(`${process.env.REACT_APP_API_URL}/reports/device-thermal`);
    url.searchParams.append('_id', dataToExport.deviceId);
    url.searchParams.append('template', dataToExport.template);
    url.searchParams.append('org', dataToExport.org);
    url.searchParams.append('startDate', dataToExport.startDateISO);
    url.searchParams.append('endDate', dataToExport.endDateISO);

    const response = await fetchWithAuth(url, {
      method: 'GET'
    });

    if (response.ok) {
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `Отчет_${utilsDatetime()}.xlsx`;

      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } else {
      console.error('Error:', response.statusText);
    }
  } catch (error) {
    console.error('Error:', error);
  }

}


export async function fetchReportsList(fetchProps) {
  const { itemsPerPage, currentPage, fullAddress, searchQuery, order, aggregateData, startDateISO, endDateISO } = fetchProps

  const url = new URL(`${process.env.REACT_APP_API_URL}/reports/get`);

  url.searchParams.append('limit', itemsPerPage);
  url.searchParams.append('offset', (currentPage * itemsPerPage) - itemsPerPage);
  url.searchParams.append('address', fullAddress)
  url.searchParams.append('search', searchQuery)
  url.searchParams.append('order', order)
  url.searchParams.append('detail', aggregateData);
  url.searchParams.append('startDate', startDateISO);
  url.searchParams.append('endDate', endDateISO);

  try {
    const response = await fetchWithAuth(url, {
      method: 'GET',
    });

    if (!response.ok) {
      throw new Error(`Error: ${response.statusText}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Failed to fetch device list:', error);
    throw error;
  }
};
